<template>
  <div class="convey-required-statement">
    <b-icon icon="info-circle"></b-icon>&nbsp;
    All fields marked with an asterisk (<span style="color: red;">&#42;</span>) are required.
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "ConveyRequiredStatement"
};
</script>

<style lang="scss">
.convey-required-statement {
  font-weight: 400;
}
</style>
